<app-header (onScrollToLoginForm)="handleScrollToLoginForm()"></app-header>
<app-features-section></app-features-section>
<app-login-form-section 
  [bannerUrl]="imageBannerPortal"
  (onLogin)="handleLogin($event)" [networkError]="networkError" [loginLoading]="loading"
  >
</app-login-form-section>
<app-benefits-section></app-benefits-section>
<app-faq-section></app-faq-section>

<div class="mobile-action">
  <button (click)="handleScrollToLoginForm()" type="button" mat-flat-button class="btn-continue" color="primary">
    Acesse sua conta
  </button>
</div>


<a class="chatbot-button" [attr.href]="isCasasBahia ? 'https://wa.me//551126265190?text=Oi%20' : 'https://wa.me//551131360845?text=Oi%20'" target="_blank">
  <img class="animate-chatbot-button" *ngIf="isCasasBahia" src="/assets/images/icone_whatts.png" alt="Icone whatsapp Casas Bahia" title="Abrir whatsapp Casas Bahia" />
  <img class="animate-chatbot-button" *ngIf="!isCasasBahia" src="/assets/images/icone_whatts.png" alt="Icone whatsapp Pontofrio" title="Abrir whatsapp Casas Bahia" />
</a>
